// ============================================================
// FYUNOR — Calculator Metadata (Lightweight)
// Static metadata for all calculators — used by the homepage,
// index page, navigation switcher, and related-calculator links.
// Does NOT import any calculator logic, keeping the initial
// JavaScript bundle small. Full definitions (with calculate
// functions, inputs, FAQs) are lazy-loaded only when a user
// visits that calculator's page.
// ============================================================

export const CALCULATOR_METADATA = [
  {
    id: "us-salary",
    slug: "salary",
    name: "Salary Calculator",
    category: "income",
    description:
      "Estimate your US take-home pay after federal tax, state tax, Social Security, Medicare, and 401(k) deductions. Built for employees, job seekers, and anyone comparing offers.",
    countries: ["US"],
    related: ["mortgage", "loan", "compound-interest"],
  },
  {
    id: "us-mortgage",
    slug: "mortgage",
    name: "Mortgage Calculator",
    category: "home",
    description:
      "Estimate your monthly mortgage payment in seconds. See your loan amount, total interest, and full repayment cost with a clear amortisation chart.",
    countries: ["US"],
    related: ["salary", "loan", "compound-interest"],
  },
  {
    id: "us-loan",
    slug: "loan",
    name: "Loan Repayment Calculator",
    category: "personal",
    description:
      "Estimate your monthly loan repayment in seconds. See your total interest, total cost, and payoff date — and discover how extra payments can save you money.",
    countries: ["US"],
    related: ["mortgage", "compound-interest"],
  },
  {
    id: "compound-interest",
    slug: "compound-interest",
    name: "Compound Interest Calculator",
    category: "savings",
    description:
      "See how your savings and investments grow with compound interest. Adjust your starting amount, contributions, and return rate to project your balance instantly.",
    countries: ["*"],
    related: ["salary", "mortgage", "loan"],
  },
];